import axios from "axios";
// import { loginRequest, msalInstance } from "../../config/authConfig";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Request interceptor - Add auth token to requests
// axiosInstance.interceptors.request.use(
//   async (config) => {
//     try {
//       const accounts = msalInstance.getAllAccounts();

//       if (accounts.length > 0) {
//         const response = await msalInstance.acquireTokenSilent({
//           ...loginRequest,
//           account: accounts[0],
//         });

//         if (response.accessToken) {
//           config.headers.Authorization = `Bearer ${response.accessToken}`;
//         }
//       }
//     } catch (error) {
//       console.error("Error acquiring token:", error);

//       // If silent token acquisition fails, try interactive
//       if (error.name === "InteractionRequiredAuthError") {
//         try {
//           const response = await msalInstance.acquireTokenPopup(loginRequest);
//           if (response.accessToken) {
//             config.headers.Authorization = `Bearer ${response.accessToken}`;
//           }
//         } catch (popupError) {
//           console.error("Popup token acquisition failed:", popupError);
//           // Optionally redirect to login or handle error
//         }
//       }
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Response interceptor - Handle responses and errors
// axiosInstance.interceptors.response.use(
//   (response) => {
//     // Any status code within the range of 2xx triggers this function
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // Handle 401 Unauthorized errors
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const accounts = msalInstance.getAllAccounts();

//         if (accounts.length > 0) {
//           // Try to refresh token
//           const response = await msalInstance.acquireTokenSilent({
//             ...loginRequest,
//             account: accounts[0],
//             forceRefresh: true,
//           });

//           if (response.accessToken) {
//             originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
//             return axiosInstance(originalRequest);
//           }
//         }
//       } catch (refreshError) {
//         console.error("Token refresh failed:", refreshError);
//         // Redirect to login page or handle logout
//         msalInstance.logoutRedirect();
//         return Promise.reject(refreshError);
//       }
//     }

//     // Handle other errors
//     if (error.response) {
//       // Server responded with error status
//       console.error("Response error:", error.response.data);
//     } else if (error.request) {
//       // Request was made but no response received
//       console.error("Network error:", error.request);
//     } else {
//       // Something else happened
//       console.error("Error:", error.message);
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
